import React from 'react';
import { withLocalize, Translate } from 'react-localize-redux';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/core/styles/withStyles';
import Lambda from '../../../aws/lambda';
import { TextField } from '@material-ui/core';

const styles = {
  button: { margin: '1rem' },
};
class ChargeDialogStart extends React.Component {
  constructor(props) {
    super(props);
    this.state = { processing: false, connector: null, notes: null };

    this.changeConnector = this.changeConnector.bind(this);
    this.submit = this.submit.bind(this);
    this.cancel = this.cancel.bind(this);
    this.secureSetState = this.secureSetState.bind(this);
    this._isMounted = false;
  }

  get isMounted() {
    return this._isMounted;
  }

  set isMounted(val) {
    this._isMounted = val;
  }

  secureSetState(state, callback) {
    if (!this.isMounted) {
      return;
    }
    this.setState(state, callback);
  }

  changeConnector(c) {
    return () => this.secureSetState({ connector: c });
  }

  componentDidMount() {
    this.isMounted = true;
  }

  componentWillUnmount() {
    this.isMounted = false;
  }

  componentDidUpdate(prevProps) {
    if (prevProps.open && !this.props.open) {
      this.secureSetState({ connector: null });
    }
  }

  submit() {
    if (this.state.processing) {
      return;
    }
    this.secureSetState({ processing: true }, async () => {
      try {
        let functionName = '';
        let payment = '';
        if (this.props.chargebox.type.msg === 'soap' && this.props.chargebox.type.version === '1.5') {
          functionName = 'OcppSoap15RemoteStartTransaction';
          payment = { amount: 0, method: 'free' };
        } else if (this.props.chargebox.type.msg === 'json' && this.props.chargebox.type.version === '1.6') {
          functionName = 'OcppJson16RemoteStartTransaction';
          payment = 'free';
        }
        let started = await Lambda.invoke(functionName, {
          user: this.props.user.id,
          transaction: {
            chargebox: this.props.chargebox.id,
            connector: this.state.connector,
            payment: payment,
            token: '000',
            notes: this.state.notes || null,
          },
        });
        if (functionName === 'OcppSoap15RemoteStartTransaction') {
          this.secureSetState({ processing: false }, () => this.props.handleClose(started, false));
        } else {
          this.secureSetState({ processing: false, notes: null }, () => this.props.handleClose(true, false));
        }
      } catch (err) {
        console.log(err);
        this.secureSetState({ processing: false }, () => this.props.handleClose(false, false));
      }
    });
  }

  cancel() {
    this.props.handleClose(false, true);
  }

  render() {
    return (
      <Dialog onClose={this.cancel} aria-labelledby='chargebox-dialog-unlock-title' open={this.props.open} fullWidth maxWidth='xs'>
        <DialogTitle id='chargebox-dialog-start-title'>
          <Translate id='chargeboxes.dialogs.start.title' />
        </DialogTitle>
        <DialogContent>
          <Typography>
            <Translate id='chargeboxes.dialogs.start.text' />
          </Typography>
          <Typography>{`${this.props.chargebox.id} - ${this.props.chargebox.alias}`}</Typography>
          <Grid container direction='row' alignItems='center' justifyContent='center' wrap='wrap'>
            {this.props.chargebox.connectors.map((c, i) => (
              <Button
                disabled={c.charging && c.charging === true ? true : false}
                key={i + 1}
                className={this.props.classes.button}
                onClick={this.changeConnector(i + 1)}
                color={this.state.connector === i + 1 ? 'primary' : 'default'}
                variant='contained'
              >
                {i + 1}
              </Button>
            ))}
          </Grid>
          <TextField
            fullWidth
            placeholder={this.props.translate('chargeboxes.dialogs.start.notes')}
            onChange={(event) => {
              this.secureSetState({ notes: event.target.value });
            }}
          ></TextField>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.cancel} color='default' autoFocus>
            <Translate id='chargeboxes.dialogs.close' />
          </Button>
          <Button onClick={this.submit} color='primary' disabled={this.state.connector === null}>
            <Translate id='chargeboxes.dialogs.start.submit' />
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default withStyles(styles)(withLocalize(ChargeDialogStart));
